module.exports = __webpack_public_path__ + "media/components/src/assets/images/icon-book/icon-book-3504e61f6b67213f71198dcade146f51.svg";